<h2 mat-dialog-title>Valider le devis {{ data.devisReference }}</h2>

<mat-dialog-content>
  <p class="info-msg">
    Saisir les informations de validation avant de confirmer.
  </p>

  <form [formGroup]="form" class="validate-form">

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Date de fin de travaux</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="devisDateFinTravaux" readonly>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      <mat-error>La date de fin de travaux est obligatoire</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Numéro du bon de commande</mat-label>
      <input matInput
             formControlName="devisNumeroBonCommande"
             [matAutocomplete]="autoBC"
             placeholder="Rechercher un BC...">
      <mat-autocomplete #autoBC="matAutocomplete"
                        [displayWith]="displayOrder"
                        (optionSelected)="selectOrder($event.option.value)">
        <mat-option *ngFor="let order of filteredOrders$ | async" [value]="order">
          <div class="bc-option">
            <span class="bc-number">{{ order.number }}</span>
            <span class="bc-detail">
              {{ order.referenceYear }}
              <span *ngIf="order.description"> — {{ order.description }}</span>
              — {{ order.montantInitial | number:'1.2-2' }} €
            </span>
          </div>
        </mat-option>
        <mat-option *ngIf="(filteredOrders$ | async)?.length === 0" disabled>
          Aucun BC trouvé — vous pouvez saisir manuellement
        </mat-option>
      </mat-autocomplete>
      <mat-error>Le numéro de bon de commande est obligatoire</mat-error>
    </mat-form-field>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" [disabled]="saving">Annuler</button>
  <button mat-raised-button color="primary"
          [disabled]="saving"
          (click)="onValider()">
    <mat-spinner *ngIf="saving" diameter="16" class="btn-spinner"></mat-spinner>
    Valider
  </button>
</mat-dialog-actions>
